import { Type } from "class-transformer";
import { IsArray, IsOptional, IsString, ValidateNested } from "class-validator";
import { IsArrayOfInstancesOf } from "../../../class-validator/class-validator-constraints";
import { FamilyStepDto } from "./family-step.dto";

export class FamilyDto {
  @IsString()
  familyName!: string;
  @IsString()
  familyNumber!: string;

  @IsOptional()
  @IsString()
  familyImageCantoId?: string;

  @IsOptional()
  @IsString()
  familyDescription?: string;

  @IsOptional()
  @IsString()
  familyPiSheetUrl?: string;

  @IsArray()
  @IsArrayOfInstancesOf(FamilyStepDto)
  @ValidateNested({ each: true })
  @Type(() => FamilyStepDto)
  steps!: FamilyStepDto[];

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  countries?: string[];
}
